import { isDefined } from "../../helpers";
export default function (store, { save = true }) {
    const { stateEditableItem } = store.getState();
    if (!isDefined(stateEditableItem?.id))
        return;
    const id = stateEditableItem.id;
    const value = stateEditableItem.currentValue;
    if (save) {
        if (stateEditableItem.type === "task") {
            const task = store.getTask(id);
            if (!task)
                return;
            if (value !== task.text) {
                store.in.exec("update-task", {
                    id,
                    task: {
                        ...task,
                        text: value,
                        edited_date: new Date(),
                    },
                });
            }
        }
        if (stateEditableItem.type === "project") {
            const project = store.getProject(id);
            if (value !== project?.label) {
                store.in.exec("update-project", {
                    id,
                    project: {
                        label: value,
                    },
                });
            }
        }
    }
    store.setState({ stateEditableItem: null });
}
//# sourceMappingURL=close.js.map